module.exports = __webpack_public_path__ + "img/jxb.5bd4458b.jpg";